import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/core/services/http.service';
import { sort } from 'src/app/core/utils/utility.functions';
import { FormControlService } from 'src/app/shared/services/form-control.service';
@Component({
  selector: 'app-insurer-field-life',
  templateUrl: './insurer-field-life.component.html',
  styleUrls: ['./insurer-field-life.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class InsurerFieldLifeComponent implements OnInit {
  @Input('lob') lob: any;
  @Input('required') isRequired = true;
  @Input('productDependent') productDependent: boolean = false;
  @Input('allRuleIdData') allRuleIdData: any;
  @Input('multiple') isMultiSelect = false;
  @Input() toolTipType: string = "";

  insurers: any = [];
  lobSelected: any = '';
  form: FormGroup;

  constructor(
    private ctrlContainer: FormGroupDirective,
    private http: HttpService,
    public activatedRoute: ActivatedRoute,
    private controlStateService: FormControlService,
  ) { }

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;
    if (this.isRequired) {
      this.form.addControl(
        'insurer',
        new FormControl(null, Validators.required)
      );
    } else {
      this.form.addControl('insurer', new FormControl(null));
    }
    this.controlStateService.register({ controlName: 'insurer', control: this.form.controls['insurer'] }, true);

    if (this.productDependent) {
      this.form.controls['product_type'].valueChanges.subscribe((val: any) => {
        if (val) {
          this.getinsurer(val);
        }
      });
    } else {
      this.getinsurer(null);
    }
  }

  getinsurer(product?: any) {
    const url = '/services/api/v1/rb_masters/life_insurer_list';
    const params: any = {};
    if (product) {
      params['product_type'] = product;
    }
    this.http.get(url, params).subscribe((res: any) => {
      this.insurers = res['data'];
      this.insurers = sort(this.insurers, 'insurer_name');
    });
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['allRuleIdData']) {
  //     if (changes['allRuleIdData'].currentValue.insurer !== undefined) {
  //       if (changes['allRuleIdData'].currentValue.insurer.length > 0) {
  //         let insurer = changes['allRuleIdData'].currentValue.insurer[0];
  //         this.getinsurer(changes['allRuleIdData'].currentValue.product_type);
  //         this.form = this.ctrlContainer.form;
  //         if (this.isRequired) {
  //           this.form.addControl(
  //             'insurer',
  //             new FormControl(null, Validators.required)
  //           );
  //         } else {
  //           this.form.addControl('insurer', new FormControl(null));
  //         }
  //         this.form.patchValue({
  //           insurer: insurer,
  //         });
  //       }
  //     }
  //   }
  // }

  ngOnDestroy(): void {
    this.form.removeControl('insurer');
  }
}
